// Carousel horizontal reutilizable.
//
// Enhance cualquier [data-the90s-carousel] con:
//   - [data-carousel-scroll]: el contenedor scrollable (ul/div)
//   - [data-carousel-prev] / [data-carousel-next]: botones (opcionales)
//
// A11y:
//   - Oculta los botones cuando no hay overflow horizontal (nada que scrollear)
//   - Marca aria-disabled cuando scrollLeft está en el extremo correspondiente
//   - El scroll container es tabbable (tabindex="0" en Liquid) — arrows del teclado
//     con foco en el track funcionan gracias al scroll-behavior nativo
//
// Sin dependencias externas. Loop de init busca todas las instancias en DOM ready
// y también en cualquier morph de section (Shopify's Section Rendering API).

function initCarousel(root) {
  if (root.dataset.the90sCarouselReady === '1') return;
  root.dataset.the90sCarouselReady = '1';

  const track = root.querySelector('[data-carousel-scroll]');
  if (!track) return;
  const prev = root.querySelector('[data-carousel-prev]');
  const next = root.querySelector('[data-carousel-next]');

  const hasOverflow = () => track.scrollWidth > track.clientWidth + 1;

  const stepPx = () => {
    const first = track.firstElementChild;
    if (!first) return track.clientWidth * 0.8;
    const rect = first.getBoundingClientRect();
    const gap = parseFloat(getComputedStyle(track).columnGap || '16');
    return rect.width + gap;
  };

  function updateArrows() {
    const overflow = hasOverflow();
    for (const btn of [prev, next]) {
      if (!btn) continue;
      btn.hidden = !overflow;
    }
    if (!overflow) return;
    const atStart = track.scrollLeft <= 1;
    const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
    if (prev) prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
    if (next) next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
  }

  if (prev) {
    prev.addEventListener('click', (e) => {
      if (prev.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
      track.scrollBy({ left: -stepPx(), behavior: 'smooth' });
    });
  }
  if (next) {
    next.addEventListener('click', (e) => {
      if (next.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
      track.scrollBy({ left: stepPx(), behavior: 'smooth' });
    });
  }

  track.addEventListener('scroll', updateArrows, { passive: true });
  window.addEventListener('resize', updateArrows, { passive: true });

  requestAnimationFrame(updateArrows);
}

function initAll(root = document) {
  for (const el of root.querySelectorAll('[data-the90s-carousel]')) initCarousel(el);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAll());
} else {
  initAll();
}

// Re-init cuando Shopify re-morfa una section (editor del tema, Section Rendering API)
document.addEventListener('shopify:section:load', (e) => initAll(e.target || document));
